// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordPage_container__zfsXp"};